import styled from 'styled-components'

const VARIANTS = {
	blue: {
		background: props => props.theme.colors.brand.backgroundBlue,
		color: props => props.theme.colors.brand.lightBlue
	},
	grey: {
		background: props => props.theme.colors.greys.lightGrey,
		color: props => props.theme.colors.text.secondaryText
	},
	success: {
		background: props => props.theme.colors.feedback.successLight,
		color: props => props.theme.colors.feedback.success
	},
	error: {
		background: props => props.theme.colors.feedback.errorLight,
		color: props => props.theme.colors.feedback.error
	}
}

export const StyledBadge = styled.span`
	align-self: flex-start;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 6px 10px;
	border-radius: 999px;
	font-size: 14px;
	font-weight: 500;
	background: ${props =>
		!props.$variant && props.$background
			? props.$background
			: (VARIANTS[props.$variant] || VARIANTS.blue).background(props)};
	color: ${props =>
		!props.$variant && props.$color
			? props.$color
			: (VARIANTS[props.$variant] || VARIANTS.blue).color(props)};
`
